import {
	cofReducer as CoFConfig,
	initState as cofInitState,
} from './CoF.reducers';
import {
	componentReducer as ComponentStore,
	initState as componentInitState,
} from './component.reducers';
import {
	lofReducer as LoFConfig,
	initState as lofInitState,
} from './LoF.reducers';
import {
	riskReducer as RiskStore,
	initState as riskInitState,
} from './Risk.reducers';
import {
	assetReducer as assets,
	initState as assetInitState,
} from './asset.reducers';
import {
	pipeDeteriorationReducer as PipeDeteriorationStore,
	initState as pipeDeteriorationInitState,
} from './pipeDeterioration.reducers';
import {
	riskTemplateCatalogReducer as RiskTemplateCatalogStore,
	initState as riskTemplateCatalogInitState,
} from './RiskTemplateCatalog.reducers';

import { StoreState } from '@Types';
import { combineReducers } from 'redux';
import { moduleNamespace } from '@Store/config.store';
import { utilReducer as util } from './util.reducer';
import { utilStoreStateInitial } from '@Types/utils.types';

export const initialState: StoreState = {
	LoFConfig: lofInitState,
	CoFConfig: cofInitState,
	RiskStore: riskInitState,
	assets: assetInitState,
	ComponentStore: componentInitState,
	PipeDeteriorationStore: pipeDeteriorationInitState,
	RiskTemplateCatalogStore: riskTemplateCatalogInitState,
	util: utilStoreStateInitial(),
};

export default combineReducers({
	LoFConfig,
	CoFConfig,
	RiskStore,
	assets,
	ComponentStore,
	PipeDeteriorationStore,
	RiskTemplateCatalogStore,
	util,
});

export const reducerKey = moduleNamespace;
